define('common/parts',["require", "exports", "services/trace", "common/tuple"], function (require, exports, Trace, Tuple) {
    "use strict";
    var Subscriber = (function () {
        function Subscriber(target, context) {
            this.target = target;
            this.context = context;
        }
        return Subscriber;
    }());
    var Pin = (function () {
        function Pin() {
            this._subscribers = [];
        }
        Pin.prototype.connect = function (subscriber, context) {
            this._subscribers.push(new Subscriber(subscriber, context));
        };
        Pin.prototype.call = function (message) {
            for (var i = 0; i < this._subscribers.length; i++) {
                if (this._subscribers) {
                    var subscriber = this._subscribers[i];
                    if (subscriber.context == null) {
                        subscriber.target(message);
                    }
                    else {
                        subscriber.target.call(subscriber.context, message);
                    }
                }
            }
        };
        return Pin;
    }());
    exports.Pin = Pin;
    var Part = (function () {
        function Part() {
            this.output = new Pin();
            this.error = new Pin();
        }
        Part.prototype.process = function (memberType, symbol) {
        };
        return Part;
    }());
    exports.Part = Part;
    var PartBinder = (function () {
        function PartBinder() {
        }
        PartBinder.bind = function (source, target, error) {
            source.output.connect(target);
            if (error == null) {
                error = function (msg) { return Trace.traceError(msg, null, "", true); };
            }
            source.error.connect(error);
            return source;
        };
        return PartBinder;
    }());
    exports.PartBinder = PartBinder;
    var Join = (function () {
        function Join() {
            this._messages = [];
            this._isSet1 = false;
            this._isSet2 = false;
            this.output = new Pin();
            this.error = new Pin();
        }
        Join.prototype.first = function (symbol) {
            this._messages[0] = symbol;
            this._isSet1 = true;
            this.raise();
        };
        Join.prototype.second = function (symbol) {
            this._messages[1] = symbol;
            this._isSet2 = true;
            this.raise();
        };
        Join.prototype.raise = function () {
            if (this._isSet1 && this._isSet2) {
                var result = new Tuple(this._messages[0], this._messages[1]);
                this.output.call(result);
                this.reset();
            }
        };
        Join.prototype.reset = function () {
            this._isSet1 = false;
            this._isSet2 = false;
            this._messages.length = 0;
        };
        return Join;
    }());
    exports.Join = Join;
    var Split = (function () {
        function Split() {
            this.output = new Pin();
            this.outputtwo = new Pin();
            this.error = new Pin();
        }
        Split.prototype.process = function (symbol) {
            try {
                this.output.call(symbol);
                this.outputtwo.call(symbol);
            }
            catch (exception) {
                this.error.call(exception);
            }
        };
        return Split;
    }());
    exports.Split = Split;
    var Throttle = (function () {
        function Throttle(delay) {
            this.output = new Pin();
            this.error = new Pin();
            this._delay = delay;
        }
        Throttle.prototype.process = function (symbol) {
            var that = this;
            setTimeout(function () {
                that.output.call(symbol);
            }, that._delay);
        };
        return Throttle;
    }());
    exports.Throttle = Throttle;
    var Progress = (function () {
        function Progress(taskManager) {
            this.output = new Pin();
            this.error = new Pin();
            this._taskManager = taskManager;
            this._defer = Q.defer();
        }
        Object.defineProperty(Progress.prototype, "deferred", {
            get: function () {
                return this._defer;
            },
            enumerable: true,
            configurable: true
        });
        Progress.prototype.start = function (message, delegate) {
            if (this._taskManager !== null)
                this._taskId = this._taskManager.add(message);
            delegate.apply(this);
        };
        Progress.prototype.process = function (symbol) {
            try {
                this.output.call(symbol);
            }
            catch (exception) {
                this.error.call(exception);
            }
            this._defer.resolve(true);
            if (this._taskManager !== null)
                this._taskManager.remove(this._taskId);
        };
        return Progress;
    }());
    exports.Progress = Progress;
});

